/* eslint-disable no-param-reassign,@typescript-eslint/no-shadow,@typescript-eslint/no-unused-vars,prefer-destructuring */

import { isEqual } from 'lodash';
import { EVENTS } from '../../../../app/constants/events';
import { DESIGNER_EVENTS } from '../../../../app/constants/designer_events';

xplenty.directive('executeSqlEditor', [
  '$timeout',
  '$rootScope',
  'ConnectionItemsResource',
  function ($timeout, $rootScope, ConnectionItemsResource) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./execute-sql-editor.html'),

      replace: true,

      link(scope) {
        scope.$watch(
          'component',
          function (component) {
            scope.buttonDisabled = !component.query || component.query.length === 0;
          },
          true,
        );

        scope.$watch(
          'packageVariables',
          function (packageVariables, oldPackageVariables) {
            if (!_.isEqual(packageVariables, oldPackageVariables))
              $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_VARIABLES_UPDATE, packageVariables);
          },
          true,
        );

        scope.$on(EVENTS.MODAL_PANEL_CLOSE, function () {
          scope.isEditorOpen = false;
        });

        scope.$on(EVENTS.PACKAGE_VARIABLES_SAVE, function (event, variables) {
          scope.packageVariables = variables;
          let variableStillExists = false;
          scope.variablesOptions = _.map(variables, function (value, text) {
            if (scope.component.result_variable === text) variableStillExists = true;
            return { value: text, text };
          });
          if (!variableStillExists) scope.component.result_variable = '';
          if (scope.$modalPanel) {
            scope.$modalPanel.remove();
          }
          scope.isEditorOpen = false;
        });
      },

      controller: [
        '$scope',
        '$rootScope',
        'connectionsService',
        '$stateParams',
        '$translate',
        '$compile',

        function ($scope, $rootScope, connectionsService, $stateParams, $translate, $compile) {
          $scope.isEditorOpen = false;
          $scope.queryLoading = false;
          $scope.data = null;
          $scope.showData = true;
          $scope.buttonDisabled = true;
          $scope.errorMessage = null;
          $scope.editorOptions = {
            mode: 'text/x-sql',
            placeholder: 'SELECT * FROM table',
          };

          $scope.resultTypes = [
            { value: 'none', text: 'execute-sql-editor.form.selects.result_type.options.none', translate: true },
            { value: 'string', text: 'execute-sql-editor.form.selects.result_type.options.string', translate: true },
            { value: 'int', text: 'execute-sql-editor.form.selects.result_type.options.int', translate: true },
            { value: 'long', text: 'execute-sql-editor.form.selects.result_type.options.long', translate: true },
            { value: 'float', text: 'execute-sql-editor.form.selects.result_type.options.float', translate: true },
            { value: 'double', text: 'execute-sql-editor.form.selects.result_type.options.double', translate: true },
            { value: 'boolean', text: 'execute-sql-editor.form.selects.result_type.options.boolean', translate: true },
            {
              value: 'datetime',
              text: 'execute-sql-editor.form.selects.result_type.options.datetime',
              translate: true,
            },
          ];

          if ($rootScope.getPackage) {
            $scope.packageVariables = angular.copy($rootScope.getPackage().variables);
            let variableStillExists = false;
            $scope.variablesOptions = _.map($scope.packageVariables, function (value, text) {
              if ($scope.component.result_variable === text) variableStillExists = true;
              return { value: text, text };
            });
            if (!variableStillExists) $scope.component.result_variable = '';
            if ($scope.component.result_variable === '') {
              const keys = Object.keys($scope.packageVariables);
              if (keys.length > 0) {
                $scope.component.result_variable = keys[0];
              }
            }
          } else {
            $scope.packageVariables = {};
            $scope.variablesOptions = [];
          }

          $scope.$watch(
            'component.connection',
            function () {
              $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADED, {
                fields: [],
                data: [],
              });
            },
            true,
          );

          $scope.onResultVariableChange = (variable) => {
            $scope.component.result_variable = variable;
          };

          $scope.onResultTypeChange = (resultType) => {
            $scope.component.result_type = resultType;
          };

          $scope.testQuery = function () {
            $scope.errorMessage = null;

            if (!$scope.component.connection || !$scope.component.connection.type) return;

            const connection = connectionsService.connections[$scope.component.connection.type];

            if (connection) {
              $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADING_STARTED);
              $scope.queryLoading = true;

              const query = {
                query: $scope.component.query,
                result_type: $scope.component.result_type,
                access_mode: 'query',
              };

              query.no_result = $scope.component.result_type === 'none';

              ConnectionItemsResource.schema(
                $scope.component.connection.type,
                $scope.component.connection.id,
                query,
              ).subscribe(
                function (res) {
                  $scope.data = res;
                  $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADING_ENDED);
                  $scope.queryLoading = false;
                },
                function (res) {
                  $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADING_ENDED);
                  $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADED, {
                    fields: [],
                    data: [],
                  });
                  if (res.error && res.error.error_message) {
                    $scope.errorMessage = res.error.error_message;
                  } else {
                    $scope.errorMessage = $translate.instant('execute-sql-editor.query_error_message');
                  }
                  $scope.queryLoading = false;
                },
              );
            }
          };

          $scope.editVariables = function () {
            $scope.isEditorOpen = true;

            const $newScope = $rootScope.$new();

            $newScope.$modalBody = angular.element('.modal-body');
            $newScope.packageVariables = $scope.packageVariables;
            $newScope.itemObject = {
              directive:
                '<package-variables-editor class="package-variables-editor-wrapper" ng-model="packageVariables"></package-variables-editor>',
            };

            $scope.$modalPanel = $compile(
              '<modal-panel modal-body="$modalBody" item-object="itemObject"></modal-panel>',
            )($newScope);
          };
        },
      ],
    };
  },
]);
